import React, { useState } from 'react';
import { Menu, X, Package, User, LogOut, Home } from 'lucide-react';

// Exemple de données fictives pour la maquette
const livraisons = [
  {
    id: 'LIV-001',
    date: '2024-07-15',
    statut: 'En cours',
    lieu: 'Marseille',
    details: 'Livraison de 10 palettes',
  },
  {
    id: 'LIV-002',
    date: '2024-07-10',
    statut: 'Livrée',
    lieu: 'Fos-sur-Mer',
    details: 'Livraison de 5 conteneurs',
  },
  {
    id: 'LIV-003',
    date: '2024-06-28',
    statut: 'En attente',
    lieu: 'Marseille',
    details: 'Livraison de 2 caisses',
  },
];

export default function ClientLivraisons() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Mobile */}
      <header className="bg-white shadow-sm border-b border-gray-200 fixed top-0 left-0 right-0 z-40">
        <div className="flex items-center justify-between px-4 py-3">
          <div className="flex items-center space-x-3">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
            >
              {menuOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
            <h1 className="text-lg font-semibold text-gray-900">ATL Client</h1>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-500">Client</span>
            <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
              <User size={16} className="text-white" />
            </div>
          </div>
        </div>
      </header>

      {/* Menu Mobile avec transition */}
      <div className={`fixed inset-0 z-50 transition-opacity duration-300 ${
        menuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}>
        {/* Overlay */}
        <div 
          className="absolute inset-0 bg-black bg-opacity-50"
          onClick={() => setMenuOpen(false)}
        />
        
        {/* Menu latéral avec transition */}
        <div className={`absolute left-0 top-0 h-full w-64 bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
          menuOpen ? 'translate-x-0' : '-translate-x-full'
        }`}>
          <div className="p-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900">Menu Client</h2>
          </div>
          <nav className="p-4">
            <ul className="space-y-2">
              <li>
                <button className="w-full flex items-center space-x-3 p-3 rounded-lg text-left hover:bg-gray-100 transition-colors">
                  <Home size={20} className="text-gray-600" />
                  <span className="text-gray-900">Accueil</span>
                </button>
              </li>
              <li>
                <button className="w-full flex items-center space-x-3 p-3 rounded-lg text-left bg-blue-50 text-blue-700">
                  <Package size={20} className="text-blue-600" />
                  <span className="font-medium">Mes Livraisons</span>
                </button>
              </li>
              <li>
                <button className="w-full flex items-center space-x-3 p-3 rounded-lg text-left hover:bg-gray-100 transition-colors">
                  <User size={20} className="text-gray-600" />
                  <span className="text-gray-900">Mon Profil</span>
                </button>
              </li>
              <li className="pt-4 border-t border-gray-200">
                <button className="w-full flex items-center space-x-3 p-3 rounded-lg text-left hover:bg-red-50 text-red-600 transition-colors">
                  <LogOut size={20} />
                  <span>Déconnexion</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      {/* Contenu Principal avec padding pour le header fixe */}
      <main className="pt-16 p-4">
        <div className="max-w-md mx-auto">
          <div className="mb-6">
            <h2 className="text-xl font-bold text-gray-900 mb-2">Mes Livraisons</h2>
            <p className="text-sm text-gray-600">Consultez l'état de vos livraisons</p>
          </div>

          <div className="space-y-3">
            {livraisons.map((livraison) => (
              <div key={livraison.id} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <h3 className="font-semibold text-gray-900">{livraison.id}</h3>
                    <p className="text-sm text-gray-600">{livraison.date} • {livraison.lieu}</p>
                  </div>
                  <span className={`text-xs px-2 py-1 rounded-full font-medium ${
                    livraison.statut === 'Livrée' 
                      ? 'bg-green-100 text-green-700' 
                      : livraison.statut === 'En cours' 
                      ? 'bg-yellow-100 text-yellow-700' 
                      : 'bg-gray-100 text-gray-600'
                  }`}>
                    {livraison.statut}
                  </span>
                </div>
                <p className="text-sm text-gray-700">{livraison.details}</p>
              </div>
            ))}
          </div>

          {livraisons.length === 0 && (
            <div className="text-center py-8">
              <Package size={48} className="mx-auto text-gray-400 mb-4" />
              <p className="text-gray-500">Aucune livraison pour le moment</p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
} 